/**
 * Helper per leggere il permesso effettivo di un utente su un (pipeline_id, stage_id).
 *
 * Le regole della matrice stage_permissions sono trasversali per gli user.
 * Gli admin ignorano la matrice e hanno sempre accesso completo.
 *
 * Default per stage NON configurato: solo VISIONE on (compromesso ragionevole
 * — l'utente vede l'opp ma non può modificarla finché l'admin non assegna
 * esplicitamente MODIFICA o FOTO).
 *
 * @param {object} user - L'utente loggato (da AuthContext). `null`/`undefined` ammessi.
 * @param {string} pipelineId
 * @param {string} stageId
 * @returns {{ vision: boolean, edit: boolean, photo: boolean }}
 */
export function getStagePermission(user, pipelineId, stageId) {
  if (!user) return { vision: false, edit: false, photo: false };
  // Admin ha sempre accesso totale, indipendentemente dalla matrice.
  if (user.role === "admin") return { vision: true, edit: true, photo: true };
  const sp = user.stage_permissions || {};
  const pipelinePerms = sp[pipelineId] || {};
  const stagePerms = pipelinePerms[stageId];
  if (!stagePerms) {
    // Default per stage non configurato: solo VISIONE.
    return { vision: true, edit: false, photo: false };
  }
  return {
    vision: !!stagePerms.vision,
    edit: !!stagePerms.edit,
    photo: !!stagePerms.photo,
  };
}
